import { useQuery } from 'react-query';
import useFeatureToggle from '@guestyci/feature-toggle-fe/useFeatureToggle';

import utils from 'utils';
import hasLegacySmartLocks from 'API/handlers/smart-locks';
import {
  gfhSmartLocksDiconectionflow,
  gfhIsUserInTrialGLM,
  smartLockSplit,
} from 'config/splits';

const useSmartLocksEnabled = () => {
  const { authenticatedData } = utils.getLocalStorageByKey('authenticatedData');
  const [, gfhSmartLocksDiconectionflowFT] = useFeatureToggle(
    gfhSmartLocksDiconectionflow
  );
  const [, gfhIsUserInTrialGlmFT] = useFeatureToggle(gfhIsUserInTrialGLM);
  const [, smartLockSplitFT] = useFeatureToggle(smartLockSplit);

  const { data: hasLegacySmartLocksConnection } = useQuery({
    enabled: true,
    queryKey: ['hasLegacySmartLocks'],
    queryFn: () => hasLegacySmartLocks(authenticatedData.baseUserInfo.userId),
    retry: 1,
  });

  return (
    smartLockSplitFT ||
    gfhIsUserInTrialGlmFT ||
    (gfhSmartLocksDiconectionflowFT && hasLegacySmartLocksConnection) ||
    (gfhSmartLocksDiconectionflowFT && !hasLegacySmartLocksConnection)
  );
};

export default useSmartLocksEnabled;
